<template>
    <section class="k-input-wrapper">
        <div class="k-input-input-div" :class="{error: errorFlag}">
            <label class="k-input-tit" v-if="label">{{label}}</label>
            <input class="k-input-input" :type="inputType" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" :placeholder="holder" @blur="handleBlur">
            <slot></slot>
            <transition name="input-fade">
                <div class="k-input-err-div" v-if="errorFlag">
                    <span>{{errMsg}}</span>
                </div>
                <div class="k-input-err-div" v-if="infoFlag">
                    <div class="k-input-info">{{infoDes}}  <span class="k-info-data">{{infoData}}</span></div>
                </div>
            </transition>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'k-input',
        props: [
            'placeholder',
            'validOptions',
            'value',
            'type',
            'label'
        ],
        data (){
            return {
                holder: 'Input something here',
                validFunc: {},
                errMsg: '',
                errorFlag: false,
                infoFlag: false,
                infoData: '',
                infoDes: ''
            }
        },
        methods: {
            handleBlur (){
                this.resetInfo()
                this.$emit('blur')
            },
            validate (val){
                var targetValue = val ? val : this.value
                if(this.validOptions && this.validOptions[0].required){
                    if(!targetValue){
                        this.errorFlag = true
                        this.errMsg = this.validOptions[0].message
                    }else{
                        this.errorFlag = false
                    }
                    return
                }
                this.validFunc ? this.validFunc(targetValue, this.cb) : ''
            },
            /**
             * 验证验证规则，之后执行callback
             * 
             * @cb  callbackFunc
             */
            cb (err){
                if(err && err.message !== 'valid'){
                    this.errorFlag = true
                    this.errMsg = err.message
                }else{
                    this.errorFlag = false
                }
            },
            reset (){
                this.errMsg = ''
                this.value = ''
                this.errorFlag = false
            },
            resetInfo (){
                this.infoFlag = false
                this.infoDes = ''
                this.infoData = ''
            },
            update (params){
                if(params && params.data){
                    this.reset()
                    this.infoFlag = params.flag
                    this.infoDes = params.des
                    this.infoData = params.data
                    
                }
            }
        },
        created (){
            this.inputType = this.type ? this.type : 'text'
            this.placeholder ? this.holder = this.placeholder : ''
            this.validFunc = this.validOptions && this.validOptions[0].validator ? this.validOptions[0].validator : null
        },
        mounted (){
          this.$on('blur', this.validate);
          this.$on('input', function (val){
                this.validate(val)
          });
        }
    
    }
</script>

<style lang="scss">

    $cl_dark : #444444;
    $cl_green : #50BBE5;

    .k-input-wrapper {
        margin-bottom: .4rem;
    }
    .k-input-input-div {
        position: relative;
        font-size: 0;
        &.error {
            .k-input-input {
                border-color: #f56c6c;
            }
        }
    }
    .k-input-tit {
        display: block;
        font-size: .12rem;
        color: $cl_dark;
        margin-bottom: .1rem;
    }
    .k-input-input {
        position: relative;
        display: inline-block;
        padding: .13rem .12rem;
        width: 100%;
        height: .4rem;
        line-height: .14rem;
        background-color: #fff;
        border: 1px solid #dcdfe6;
        color: #444;
        font-size: .12rem;
        outline: 0;
        border-radius: .2rem;
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        &:hover {
            border-color: #c0c4cc;
        }
        &:focus {
            border-color: $cl_green;
        }
    }
    .k-input-err-div {
        display: block;
        padding-top: .04rem;
        line-height: .14rem;
        font-size: .1rem;
        color: #f56c6c;
        text-align: center;
        .k-input-info {
            color: #999;
        }
        .k-info-data {
            color: #50BBE5;
        }
    }
    .input-fade-enter-active, .input-fade-leave-active {
        transition: all .5s;
    }
    .input-fade-enter, .input-fade-leave-to {
        opacity: 0;
        transform: translateY(-30%);
        -webkit-transform: translateY(-30%);
    }
</style>


